import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { buildMusicSeoPage } from './musicExplorerSeo';
import './MusicExplorerPublicPage.css';

export default function MusicExplorerSeoPage({ kind }) {
  const params = useParams();
  const page = buildMusicSeoPage(kind, params);
  React.useEffect(() => {
    if (!page) return undefined;
    const previous = document.title;
    document.title = `${page.title} | Music Explorer`;
    return () => { document.title = previous; };
  }, [page]);
  if (!page) return <main className="mep-public mep-public__seo"><h1>Music page not found</h1><Link to="/music-explorer">Return to Music Explorer</Link></main>;
  const schema = { '@context': 'https://schema.org', '@type': page.answer ? 'FAQPage' : 'WebPage', name: page.title, description: page.description };
  return <main className="mep-public mep-public__seo">
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
    <p className="mep-public__eyebrow">MUSIC EXPLORER · SOURCED REFERENCE</p>
    <h1>{page.title}</h1>
    <p className="mep-public__lead">{page.answer || page.description}</p>
    <section className="mep-public__seo-grid">{page.entities.map((entity) => <article key={entity.name}><h2>{entity.name}</h2><p><i>{entity.sub}</i></p>{entity.note ? <p>{entity.note}</p> : null}{entity.meta ? <p>{entity.meta}</p> : null}<small>Source: {entity.source}. Recheck the live product for full metadata and any conflicts.</small></article>)}</section>
    <p>These public pages expose only reviewed, source-backed fields. They do not stream audio, publish lyrics or display unlicensed cover art.</p>
    <Link className="mep-public__primary" to="/music-explorer">Explore the full product</Link>
  </main>;
}
